import React from 'react';
import { Link } from 'react-router-dom';
import { XIcon } from 'lucide-react';

/**
 * AuthPopup
 * A modern, attractive modal prompting the user to log in when accessing protected actions.
 * Includes a book pages turning GIF for visual interest.
 */
export default function AuthPopup({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-6 w-full max-w-md mx-4">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
        >
          <XIcon size={20} />
        </button>

        {/* GIF Illustration */}
        <img
          src="/assets/book-turning.gif"
          alt="Turning book pages"
          className="h-40 mx-auto mb-4"
        />

        {/* Title & Message */}
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 text-center mb-2">
          Whoops! You&apos;re not signed in.
        </h2>
        <p className="text-center text-gray-600 dark:text-gray-300 mb-6">
          To add items to your cart or wishlist, please log in or sign up.
        </p>

        {/* Action Buttons */}
        <div className="flex justify-center space-x-4">
          <Link
            to="/login"
            className="px-6 py-2 bg-primary-shade3 hover:bg-primary-shade4 text-white rounded-full font-medium transition"
          >
            Log In
          </Link>
          <Link
            to="/signup"
            className="px-6 py-2 border-2 border-primary-shade3 hover:bg-primary-shade1 text-primary-shade5 rounded-full font-medium transition"
          >
            Sign Up
          </Link>
        </div>
      </div>
    </div>
  );
}

/**
 * Usage Example:
 *
 * const [showAuth, setShowAuth] = useState(false);
 *
 * <button onClick={() => setShowAuth(true)}>Add to Cart</button>
 *
 * <AuthPopup isOpen={showAuth} onClose={() => setShowAuth(false)} />
 */
